import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function utcTime(time?: dayjs.ConfigType) {
  if (!time) {
    return dayjs().utc();
  }
  return dayjs.utc(time);
}

export function localTime(time: dayjs.ConfigType) {
  return utcTime(time).local();
}
